import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { StyledModal } from "@root/components/modals/StyledModal";
import { ColumnBox } from "@root/components/common/ColumnBox";
import { ModalView } from "@root/components/modals/common/ModalView";
import { DeleteScope } from "@root/utils/types";

interface RecurringEventEditModalProps {
  open: boolean;
  onClose: () => void;
  onEdit: (scope: DeleteScope) => void;
  eventName?: string;
  hasParent?: boolean;
}

export const RecurringEventEditModal: React.FC<
  RecurringEventEditModalProps
> = ({ open, onClose, onEdit, eventName, hasParent }) => {
  return (
    <StyledModal open={open} onClose={onClose}>
      <ColumnBox>
        <ModalView title="Edit Recurring Event">
          <Typography
            variant="body2"
            sx={{ textAlign: "center", whiteSpace: "pre-wrap", mb: 2 }}
          >
            {`"${eventName || ""}" is a recurring event. How would you like to edit it?`}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              width: "100%",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => onEdit("Single")}
              sx={{ width: "100%", textTransform: "none" }}
            >
              Edit this event only
            </Button>
            {hasParent && (
              <Button
                variant="outlined"
                onClick={() => onEdit("AllFuture")}
                sx={{ width: "100%", textTransform: "none" }}
              >
                Edit this and following events
              </Button>
            )}
            <Button
              variant="contained"
              color="primary"
              onClick={() => onEdit("EntireSeries")}
              sx={{ width: "100%", textTransform: "none" }}
            >
              Edit all events in series
            </Button>
            <Button
              variant="text"
              onClick={onClose}
              sx={{ width: "100%", textTransform: "none", mt: 1 }}
            >
              Cancel
            </Button>
          </Box>
        </ModalView>
      </ColumnBox>
    </StyledModal>
  );
};
